import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Channel from "../pages/channel/page";
import ArticleDetail from "../pages/article/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/channel/:slug", element: <Channel /> },
  { path: "/article/:id", element: <ArticleDetail /> },
  { path: "/about", element: <About /> },
  { path: "*", element: <NotFound /> },
];

export default routes;